import { HttpClient } from './http-client/http.client';

// #region Typings
interface ShipClientDependencies {
  host: string;
  httpClient: HttpClient;
}
// #endregion Typings

class ShipClient {
  host: string;

  httpClient: HttpClient;

  constructor({ host, httpClient }: ShipClientDependencies) {
    this.host = host;
    this.httpClient = httpClient;
  }

  async listShips(): Promise<Record<string, any>[]> {
    const url = this.buildUrl('getLineUp?api-version=2016-06-01');

    const { body } = await this.httpClient.get({ url });

    // const body = mock;

    return body;
  }

  private buildUrl(path: string): string {
    return [this.host, path]
      .filter(Boolean)
      .map((p) => p.replace(/^\//, '').replace(/\/$/, ''))
      .join('/');
  }
}

export default ShipClient;

const mock = [
  {
    '@odata.etag': '',
    ItemInternalId: '5b74a5fd-c766-4644-aae5-74a5fd0af9e5',
    ROW_NUM: 65,
    NAVIO: 'MERCOSUL SUAPE',
    VIAGEM: '13334 - 0BCBXN1RC/0BCBXN1RC',
    RAP: '07135/2022',
    JOINT: 'BCO',
    ABERTURAGATE: '2022-09-12T00:01:00Z',
    BERCO: 'TECON1.1',
    DEADLINE: '2022-09-16T12:00:00Z',
    PREVISAOCHEGADA: '2022-09-18T07:00:00Z',
    CHEGADA: '2022-09-18T06:15:00Z',
    ATRACACAO: '2022-09-18T06:15:00Z',
    INICIOOPERACAO: '2022-09-18T08:44:00Z',
    TERMINO: '2022-09-18T16:42:00Z',
    SAIDA: '2022-09-19T00:05:00Z',
  },
  {
    '@odata.etag': '',
    ItemInternalId: '19cb0349-888a-4306-86c2-61ec9b0ed672',
    ROW_NUM: 66,
    NAVIO: 'NORTHERN PRIORITY',
    VIAGEM: '13333 - 237W/237W',
    RAP: '07356/2022',
    JOINT: 'COS',
    ABERTURAGATE: '2022-09-11T00:00:00Z',
    BERCO: 'TECON1.1',
    DEADLINE: '2022-09-15T12:00:00Z',
    PREVISAOCHEGADA: '2022-09-16T23:30:00Z',
    CHEGADA: '2022-09-17T01:40:00Z',
    ATRACACAO: '2022-09-17T01:40:00Z',
    INICIOOPERACAO: '2022-09-17T03:16:00Z',
    TERMINO: '2022-09-17T07:27:00Z',
    SAIDA: '2022-09-17T10:35:00Z',
  },
  {
    '@odata.etag': '',
    ItemInternalId: '755fc357-3d21-45f6-b9b2-000b2fe32522',
    ROW_NUM: 67,
    NAVIO: 'TENO',
    VIAGEM: '13332 - MM233A/MM233A',
    JOINT: 'WME',
    BERCO: 'TECON1.1',
    PREVISAOCHEGADA: '2022-09-16T17:00:00Z',
    CHEGADA: '2022-09-17T13:00:00Z',
    ATRACACAO: '2022-09-17T13:00:00Z',
    INICIOOPERACAO: '2022-09-17T15:10:00Z',
    TERMINO: '2022-09-18T19:45:00Z',
    SAIDA: '2022-09-18T20:45:00Z',
  },
  {
    '@odata.etag': '',
    ItemInternalId: '87cda422-c49d-4a87-85e9-65f20ccaf9e1',
    ROW_NUM: 68,
    NAVIO: 'LOGIN PANTANAL',
    VIAGEM: '13330 - 421N/421N',
    RAP: '07255 2022',
    JOINT: 'FED',
    ABERTURAGATE: '2022-09-03T00:00:00Z',
    BERCO: 'TECON1.1',
    DEADLINE: '2022-09-15T12:00:00Z',
    PREVISAOCHEGADA: '2022-09-16T07:00:00Z',
    CHEGADA: '2022-09-16T06:55:00Z',
    ATRACACAO: '2022-09-16T06:55:00Z',
    INICIOOPERACAO: '2022-09-16T09:12:00Z',
    TERMINO: '2022-09-16T19:29:00Z',
    SAIDA: '2022-09-16T20:10:00Z',
  },
  {
    '@odata.etag': '',
    ItemInternalId: '8973c752-ae4c-47b9-9cfe-3fed358d50de',
    ROW_NUM: 69,
    NAVIO: 'CMA CGM RODOLPHE',
    VIAGEM: '13326 - 0AACPW1MA/0AACPW1MA',
    RAP: '07205/2022',
    JOINT: 'SE1',
    ABERTURAGATE: '2022-09-06T00:00:00Z',
    BERCO: 'TECON1.1',
    DEADLINE: '2022-09-09T12:00:00Z',
    PREVISAOCHEGADA: '2022-09-12T15:00:00Z',
    CHEGADA: '2022-09-12T14:45:00Z',
    ATRACACAO: '2022-09-12T14:45:00Z',
    INICIOOPERACAO: '2022-09-12T16:19:00Z',
    TERMINO: '2022-09-13T12:01:00Z',
    SAIDA: '2022-09-13T15:25:00Z',
  },
  {
    '@odata.etag': '',
    ItemInternalId: '51fd4f1e-7197-4a52-a682-7f2fbcc567d5',
    ROW_NUM: 70,
    NAVIO: 'MONTE ALEGRE',
    VIAGEM: '13324 - 235N/235S',
    RAP: '07206/2022',
    JOINT: 'TGO',
    ABERTURAGATE: '2022-09-06T00:01:00Z',
    BERCO: 'TECON1.1',
    DEADLINE: '2022-09-09T20:00:00Z',
    PREVISAOCHEGADA: '2022-09-12T02:00:00Z',
    CHEGADA: '2022-09-12T03:50:00Z',
    ATRACACAO: '2022-09-12T03:50:00Z',
    INICIOOPERACAO: '2022-09-12T04:14:00Z',
    TERMINO: '2022-09-12T08:08:00Z',
    SAIDA: '2022-09-12T10:35:00Z',
  },
  {
    '@odata.etag': '',
    ItemInternalId: 'd6d7084f-6c0c-4b7e-b8bd-7b2597f57f01',
    ROW_NUM: 71,
    NAVIO: 'MERCOSUL SANTOS',
    VIAGEM: '13323 - 0BCBVN1RC/0BCBVN1RC',
    RAP: '06940/2022',
    JOINT: 'BCO',
    ABERTURAGATE: '2022-09-05T00:01:00Z',
    BERCO: 'TECON1.1',
    DEADLINE: '2022-09-09T12:00:00Z',
    PREVISAOCHEGADA: '2022-09-11T09:00:00Z',
    CHEGADA: '2022-09-11T10:40:00Z',
    ATRACACAO: '2022-09-11T10:40:00Z',
    INICIOOPERACAO: '2022-09-11T11:54:00Z',
    TERMINO: '2022-09-11T15:40:00Z',
    SAIDA: '2022-09-11T17:00:00Z',
  },
  {
    '@odata.etag': '',
    ItemInternalId: 'f34526f9-bef6-4d75-9c81-2fd0a5922a92',
    ROW_NUM: 72,
    NAVIO: 'GSL MELINA',
    VIAGEM: '13319 - 236W/236W',
    RAP: '07138 2022',
    JOINT: 'COS',
    ABERTURAGATE: '2022-09-04T00:00:00Z',
    BERCO: 'TECON1.1',
    DEADLINE: '2022-09-08T12:00:00Z',
    PREVISAOCHEGADA: '2022-09-09T20:30:00Z',
    CHEGADA: '2022-09-10T03:50:00Z',
    ATRACACAO: '2022-09-10T03:50:00Z',
    INICIOOPERACAO: '2022-09-10T06:13:00Z',
    TERMINO: '2022-09-10T13:39:00Z',
    SAIDA: '2022-09-10T17:50:00Z',
  },
  {
    '@odata.etag': '',
    ItemInternalId: 'c9134864-e06c-41a8-8643-fd9dda86e457',
    ROW_NUM: 1,
    NAVIO: 'AL SAFAT',
    VIAGEM: '379446 - 244N/244N',
    JOINT: 'TGO',
    ABERTURAGATE: '2022-11-09T00:01:00Z',
    BERCO: 'TECON1.2',
    DEADLINE: '2022-11-11T17:00:00Z',
    PREVISAOCHEGADA: '2022-11-15T18:00:00Z',
  },
  {
    '@odata.etag': '',
    ItemInternalId: '716af420-cb45-49ff-814a-d3d9722f4de2',
    ROW_NUM: 2,
    NAVIO: 'ANTOFAGASTA EXPRESS',
    VIAGEM: '379501 - 245W/245W',
    JOINT: 'COS',
    ABERTURAGATE: '2022-11-06T00:01:00Z',
    BERCO: 'PROLONGAM',
    DEADLINE: '2022-11-10T12:00:00Z',
    PREVISAOCHEGADA: '2022-11-13T11:00:00Z',
  },
  {
    '@odata.etag': '',
    ItemInternalId: 'a52ea87d-dbda-4440-b473-ad60250c6062',
    ROW_NUM: 3,
    NAVIO: 'MERCOSUL SUAPE',
    VIAGEM: '379507 - 0BCCDN1RC/0BCCDN1RC',
    JOINT: 'BCO',
    ABERTURAGATE: '2022-11-07T00:01:00Z',
    BERCO: 'PROLONGAM',
    DEADLINE: '2022-11-11T12:00:00Z',
    PREVISAOCHEGADA: '2022-11-13T05:00:00Z',
  },
  {
    '@odata.etag': '',
    ItemInternalId: '34cfd02f-bb23-4a63-bb39-c78b4b06fc10',
    ROW_NUM: 4,
    NAVIO: 'LOGIN RESILIENTE',
    VIAGEM: '396886 - 346N/346N',
    JOINT: 'FED',
    ABERTURAGATE: '2022-11-04T00:00:00Z',
    DEADLINE: '2022-11-09T17:00:00Z',
    PREVISAOCHEGADA: '2022-11-10T18:00:00Z',
  },
  {
    '@odata.etag': '',
    ItemInternalId: '7c4054b9-582b-4c58-be3c-8dbc1ee9199c',
    ROW_NUM: 5,
    NAVIO: 'COSCO SHIPPING THAMES',
    VIAGEM: '390381 - 024W/024W',
    JOINT: 'SE1',
    ABERTURAGATE: '2022-11-03T07:00:00Z',
    BERCO: 'PROLONGAM',
    DEADLINE: '2022-11-08T12:00:00Z',
    PREVISAOCHEGADA: '2022-11-09T07:00:00Z',
  },
  {
    '@odata.etag': '',
    ItemInternalId: '164c33fc-7dc0-4eb7-bb21-5ec4b72ba0bd',
    ROW_NUM: 6,
    NAVIO: 'MSC AQUARIUS',
    VIAGEM: '399733 - 2239N/2239N',
    JOINT: 'USG',
    ABERTURAGATE: '2022-11-07T23:30:00Z',
    DEADLINE: '2022-11-08T11:00:00Z',
    PREVISAOCHEGADA: '2022-11-07T23:30:00Z',
  },
  {
    '@odata.etag': '',
    ItemInternalId: '5fbaf87f-ebf8-43fe-9efa-202fd0977cec',
    ROW_NUM: 7,
    NAVIO: 'MONTE CERVANTES',
    VIAGEM: '379435 - 243N/243N',
    JOINT: 'TGO',
    ABERTURAGATE: '2022-11-01T00:00:00Z',
    BERCO: 'TECON1.1',
    DEADLINE: '2022-11-04T16:00:00Z',
    PREVISAOCHEGADA: '2022-11-07T07:00:00Z',
    CHEGADA: '2022-11-07T07:00:00Z',
    ATRACACAO: '2022-11-07T07:30:00Z',
    INICIOOPERACAO: '2022-11-07T07:34:00Z',
  },
  {
    '@odata.etag': '',
    ItemInternalId: 'b04d0b75-a959-47a7-81a7-13665aedfe0c',
    ROW_NUM: 8,
    NAVIO: 'MERCOSUL SANTOS',
    VIAGEM: '379494 - 0BCCBN1RC/0BCCBN1RC',
    JOINT: 'BCO',
    ABERTURAGATE: '2022-10-31T00:01:00Z',
    BERCO: 'TECON1.1',
    DEADLINE: '2022-11-04T11:00:00Z',
    PREVISAOCHEGADA: '2022-11-06T05:00:00Z',
    CHEGADA: '2022-11-06T05:50:00Z',
    ATRACACAO: '2022-11-06T07:25:00Z',
    INICIOOPERACAO: '2022-11-06T07:40:00Z',
    TERMINO: '2022-11-06T14:29:00Z',
    SAIDA: '2022-11-06T16:36:00Z',
  },
  {
    '@odata.etag': '',
    ItemInternalId: 'fb60f0d7-7dd4-41c3-a0b9-6c4f24b4bb12',
    ROW_NUM: 9,
    NAVIO: 'CMA CGM PARANAGUA',
    VIAGEM: '13420 - 0GBWKN1MA/0GBWKN1MA',
    JOINT: 'BZX',
    ABERTURAGATE: '2022-10-31T00:01:00Z',
    BERCO: 'TECON1.2',
    DEADLINE: '2022-11-03T17:00:00Z',
    PREVISAOCHEGADA: '2022-11-05T15:00:00Z',
    CHEGADA: '2022-11-05T16:00:00Z',
    ATRACACAO: '2022-11-05T17:50:00Z',
    INICIOOPERACAO: '2022-11-05T18:00:00Z',
  },
  {
    '@odata.etag': '',
    ItemInternalId: '748d7433-9d05-46d5-a2ad-5790b7d7d083',
    ROW_NUM: 10,
    NAVIO: 'EVER LOADING',
    VIAGEM: '13419 - 1505-054W/1505-054W',
    JOINT: 'SE1',
    ABERTURAGATE: '2022-10-24T00:01:00Z',
    BERCO: 'PROLONGAM',
    DEADLINE: '2022-10-25T12:00:00Z',
    PREVISAOCHEGADA: '2022-11-04T14:00:00Z',
    CHEGADA: '2022-11-04T14:00:00Z',
    ATRACACAO: '2022-11-04T16:15:00Z',
    INICIOOPERACAO: '2022-11-04T16:40:00Z',
    TERMINO: '2022-11-05T11:19:00Z',
    SAIDA: '2022-11-05T13:13:00Z',
  },
  {
    '@odata.etag': '',
    ItemInternalId: '0e209669-53dd-429f-8204-373276c43caf',
    ROW_NUM: 11,
    NAVIO: 'LOGIN RESILIENTE',
    VIAGEM: '391088 - 345N/345N',
    JOINT: 'FED',
    ABERTURAGATE: '2022-10-28T00:00:00Z',
    BERCO: 'TECON1.1',
    DEADLINE: '2022-11-01T18:00:00Z',
    PREVISAOCHEGADA: '2022-11-04T08:30:00Z',
    CHEGADA: '2022-11-04T09:25:00Z',
    ATRACACAO: '2022-11-04T11:00:00Z',
    INICIOOPERACAO: '2022-11-04T11:02:00Z',
    TERMINO: '2022-11-04T16:30:00Z',
    SAIDA: '2022-11-04T17:00:00Z',
  },
  {
    '@odata.etag': '',
    ItemInternalId: '300c0c0f-5a92-468a-88ce-03131b05d4ad',
    ROW_NUM: 12,
    NAVIO: 'GRANDE NIGERIA',
    VIAGEM: '399369 - 622S/622S',
    JOINT: 'GRI',
    ABERTURAGATE: '2022-10-28T00:00:00Z',
    DEADLINE: '2022-10-31T17:00:00Z',
    PREVISAOCHEGADA: '2022-11-03T07:00:00Z',
  },
  {
    '@odata.etag': '',
    ItemInternalId: '83dd0d93-17d6-46f5-8d81-ee401620e5df',
    ROW_NUM: 13,
    NAVIO: 'LUTETIA',
    VIAGEM: '13418 - 0GBD4N1MA/0GBD4N1MA',
    JOINT: 'BZX',
    ABERTURAGATE: '2022-10-22T07:00:00Z',
    BERCO: 'TECON1.2',
    DEADLINE: '2022-10-31T12:00:00Z',
    PREVISAOCHEGADA: '2022-11-02T14:30:00Z',
    CHEGADA: '2022-11-02T13:05:00Z',
    ATRACACAO: '2022-11-02T14:30:00Z',
    INICIOOPERACAO: '2022-11-02T16:00:00Z',
    TERMINO: '2022-11-04T16:18:00Z',
    SAIDA: '2022-11-04T16:24:00Z',
  },
  {
    '@odata.etag': '',
    ItemInternalId: '623513a9-23b7-4113-a73c-680c7e9995eb',
    ROW_NUM: 14,
    NAVIO: 'MSC AJACCIO',
    VIAGEM: '397062 - MM240A/MM240A',
    JOINT: 'MED',
    ABERTURAGATE: '2022-11-05T00:00:00Z',
    DEADLINE: '2022-11-10T00:00:00Z',
    PREVISAOCHEGADA: '2022-11-01T07:00:00Z',
  },
  {
    '@odata.etag': '',
    ItemInternalId: '0bf28691-656e-4bbd-91c6-d4b87406f0b6',
    ROW_NUM: 15,
    NAVIO: 'CMA CGM NIAGARA',
    VIAGEM: '390362 - 0AAD1W1MA/0AAD1W1MA',
    JOINT: 'SE1',
    ABERTURAGATE: '2022-10-25T07:00:00Z',
    BERCO: 'PROLONGAM',
    DEADLINE: '2022-10-28T12:00:00Z',
    PREVISAOCHEGADA: '2022-10-31T12:00:00Z',
    CHEGADA: '2022-10-31T12:00:00Z',
    ATRACACAO: '2022-10-31T14:10:00Z',
    INICIOOPERACAO: '2022-10-31T16:31:00Z',
    TERMINO: '2022-11-01T20:57:00Z',
    SAIDA: '2022-11-01T21:00:00Z',
  },
  {
    '@odata.etag': '',
    ItemInternalId: 'e2fe8f5b-6b95-443f-9928-50e33536396e',
    ROW_NUM: 16,
    NAVIO: 'MONTE ALEGRE',
    VIAGEM: '379373 - 242N/242N',
    JOINT: 'TGO',
    ABERTURAGATE: '2022-10-25T07:00:00Z',
    BERCO: 'TECON1.1',
    DEADLINE: '2022-10-28T19:00:00Z',
    PREVISAOCHEGADA: '2022-10-31T00:00:00Z',
    CHEGADA: '2022-10-31T00:02:00Z',
    ATRACACAO: '2022-10-31T01:30:00Z',
    INICIOOPERACAO: '2022-10-31T02:40:00Z',
    TERMINO: '2022-10-31T09:00:00Z',
    SAIDA: '2022-10-31T10:30:00Z',
  },
  {
    '@odata.etag': '',
    ItemInternalId: '5e6784da-f5d4-4f85-93ca-f07aa073aaac',
    ROW_NUM: 17,
    NAVIO: 'MSC ATHENS',
    VIAGEM: '394432 - NA239A/NA239A',
    JOINT: 'NWC',
    ABERTURAGATE: '2022-10-24T00:00:00Z',
    DEADLINE: '2022-10-28T17:00:00Z',
    PREVISAOCHEGADA: '2022-10-30T16:00:00Z',
  },
  {
    '@odata.etag': '',
    ItemInternalId: '8187f2a2-ae76-459d-a4da-65ae561fa566',
    ROW_NUM: 18,
    NAVIO: 'MERCOSUL ITAJAI',
    VIAGEM: '379488 - 0BCC9N1RC/0BCC9N1RC',
    JOINT: 'BCO',
    ABERTURAGATE: '2022-10-24T00:01:00Z',
    BERCO: 'PROLONGAM',
    DEADLINE: '2022-10-28T11:00:00Z',
    PREVISAOCHEGADA: '2022-10-30T05:00:00Z',
    CHEGADA: '2022-10-30T06:50:00Z',
    ATRACACAO: '2022-10-30T08:20:00Z',
    INICIOOPERACAO: '2022-10-30T08:35:00Z',
    TERMINO: '2022-10-30T18:45:00Z',
    SAIDA: '2022-10-30T20:35:00Z',
  },
  {
    '@odata.etag': '',
    ItemInternalId: '6f775aa9-2b08-4c96-8411-998268ac0242',
    ROW_NUM: 19,
    NAVIO: 'CMA CGM VERACRUZ',
    VIAGEM: '13415 - 0GBCWN1MA/0GBCWN1MA',
    JOINT: 'BZX',
    ABERTURAGATE: '2022-10-17T00:10:00Z',
    BERCO: 'TECON1.2',
    DEADLINE: '2022-10-27T12:00:00Z',
    PREVISAOCHEGADA: '2022-10-29T02:00:00Z',
    CHEGADA: '2022-10-29T08:30:00Z',
    ATRACACAO: '2022-10-29T10:15:00Z',
    INICIOOPERACAO: '2022-10-29T10:25:00Z',
    TERMINO: '2022-10-31T10:30:00Z',
    SAIDA: '2022-10-31T10:43:00Z',
  },
  {
    '@odata.etag': '',
    ItemInternalId: '4214ecbc-54fb-4e9c-8a35-c86fd0b0970d',
    ROW_NUM: 20,
    NAVIO: 'GSL MELINA',
    VIAGEM: '379486 - 243W/243W',
    JOINT: 'COS',
    ABERTURAGATE: '2022-10-23T00:01:00Z',
    BERCO: 'PROLONGAM',
    DEADLINE: '2022-10-27T12:00:00Z',
    PREVISAOCHEGADA: '2022-10-28T19:00:00Z',
    CHEGADA: '2022-10-28T17:25:00Z',
    ATRACACAO: '2022-10-28T20:25:00Z',
    INICIOOPERACAO: '2022-10-28T21:12:00Z',
    TERMINO: '2022-10-29T03:05:00Z',
    SAIDA: '2022-10-29T04:20:00Z',
  },
  {
    '@odata.etag': '',
    ItemInternalId: '6e5f4d57-e48a-4150-8310-37d210f84e6d',
    ROW_NUM: 21,
    NAVIO: 'LOGIN RESILIENTE',
    VIAGEM: '387170 - 344N/344N',
    JOINT: 'FED',
    ABERTURAGATE: '2022-10-21T00:00:00Z',
    BERCO: 'TECON1.2',
    DEADLINE: '2022-10-26T17:00:00Z',
    PREVISAOCHEGADA: '2022-10-28T01:00:00Z',
    CHEGADA: '2022-10-28T01:00:00Z',
    ATRACACAO: '2022-10-28T03:00:00Z',
    INICIOOPERACAO: '2022-10-28T05:01:00Z',
    TERMINO: '2022-10-28T11:41:00Z',
    SAIDA: '2022-10-28T13:02:00Z',
  },
  {
    '@odata.etag': '',
    ItemInternalId: '6c60be18-572f-4ba3-84df-003a456872c1',
    ROW_NUM: 22,
    NAVIO: 'CZECH',
    VIAGEM: '394398 - NA238A/NA238A',
    JOINT: 'NWC',
    ABERTURAGATE: '2022-10-21T00:00:00Z',
    DEADLINE: '2022-10-25T17:00:00Z',
    PREVISAOCHEGADA: '2022-10-27T17:00:00Z',
  },
  {
    '@odata.etag': '',
    ItemInternalId: 'd24ef976-182b-4dac-84a0-932716f0e776',
    ROW_NUM: 23,
    NAVIO: 'EVER LENIENT',
    VIAGEM: '13410 - 1502-052W/1502-052W',
    JOINT: 'SE1',
    ABERTURAGATE: '2022-10-19T07:00:00Z',
    BERCO: 'PROLONGAM',
    DEADLINE: '2022-10-25T14:00:00Z',
    PREVISAOCHEGADA: '2022-10-26T12:00:00Z',
    CHEGADA: '2022-10-26T12:00:00Z',
    ATRACACAO: '2022-10-26T13:37:00Z',
    INICIOOPERACAO: '2022-10-26T16:16:00Z',
    TERMINO: '2022-10-27T13:20:00Z',
    SAIDA: '2022-10-27T13:50:00Z',
  },
  {
    '@odata.etag': '',
    ItemInternalId: 'fb5c3124-50cd-4a22-a4ab-22eb6318dcd8',
    ROW_NUM: 24,
    NAVIO: 'MSC ALBANY',
    VIAGEM: '390337 - MM239A/MM239A',
    JOINT: 'MED',
    ABERTURAGATE: '2022-10-20T00:00:00Z',
    DEADLINE: '2022-10-24T18:00:00Z',
    PREVISAOCHEGADA: '2022-10-26T08:00:00Z',
  },
  {
    '@odata.etag': '',
    ItemInternalId: '4ed84a6e-eb34-4920-935d-753c4e2ead79',
    ROW_NUM: 25,
    NAVIO: 'PANAMANA',
    VIAGEM: '381976 - 28FS/28FS',
    JOINT: 'BBK',
    ABERTURAGATE: '2022-10-15T07:00:00Z',
    BERCO: 'TECON1.2',
    DEADLINE: '2022-10-23T16:00:00Z',
    PREVISAOCHEGADA: '2022-10-26T05:00:00Z',
    CHEGADA: '2022-10-26T06:00:00Z',
    ATRACACAO: '2022-10-26T07:00:00Z',
    INICIOOPERACAO: '2022-10-26T08:35:00Z',
    TERMINO: '2022-10-26T15:35:00Z',
    SAIDA: '2022-10-26T23:15:00Z',
  },
  {
    '@odata.etag': '',
    ItemInternalId: '5de44161-ad9a-4e0e-93a5-331f126e23b5',
    ROW_NUM: 26,
    NAVIO: 'MONTE OLIVIA',
    VIAGEM: '373723 - 241N/241N',
    JOINT: 'TGO',
    ABERTURAGATE: '2022-10-18T00:01:00Z',
    BERCO: 'TECON1.2',
    DEADLINE: '2022-10-21T18:30:00Z',
    PREVISAOCHEGADA: '2022-10-25T16:00:00Z',
    CHEGADA: '2022-10-25T17:00:00Z',
    ATRACACAO: '2022-10-25T17:55:00Z',
    INICIOOPERACAO: '2022-10-25T18:35:00Z',
    TERMINO: '2022-10-26T00:52:00Z',
    SAIDA: '2022-10-26T02:15:00Z',
  },
  {
    '@odata.etag': '',
    ItemInternalId: 'ea3215e6-36bf-4f0e-a366-6c0c765f3b2a',
    ROW_NUM: 27,
    NAVIO: 'BOMAR PRAIA',
    VIAGEM: '13413 - 0GBWEN1MA/0GBWEN1MA',
    JOINT: 'BZX',
    ABERTURAGATE: '2022-10-13T00:00:00Z',
    BERCO: 'TECON1.2',
    DEADLINE: '2022-10-19T12:00:00Z',
    PREVISAOCHEGADA: '2022-10-24T01:00:00Z',
    CHEGADA: '2022-10-24T18:30:00Z',
    ATRACACAO: '2022-10-24T19:50:00Z',
    INICIOOPERACAO: '2022-10-24T20:02:00Z',
    TERMINO: '2022-10-25T07:48:00Z',
    SAIDA: '2022-10-25T07:51:00Z',
  },
  {
    '@odata.etag': '',
    ItemInternalId: '76016083-2830-435f-b7a1-b7b9282ab5e0',
    ROW_NUM: 28,
    NAVIO: 'LOG-IN POLARIS',
    VIAGEM: '13416 - 076N/076N',
    JOINT: 'BCO',
    ABERTURAGATE: '2022-10-17T00:01:00Z',
    BERCO: 'PROLONGAM',
    DEADLINE: '2022-10-21T12:00:00Z',
    PREVISAOCHEGADA: '2022-10-23T00:00:00Z',
    CHEGADA: '2022-10-23T00:01:00Z',
    ATRACACAO: '2022-10-23T01:40:00Z',
    INICIOOPERACAO: '2022-10-23T03:13:00Z',
    TERMINO: '2022-10-23T07:42:00Z',
    SAIDA: '2022-10-23T12:30:00Z',
  },
  {
    '@odata.etag': '',
    ItemInternalId: 'e2620604-adff-4452-aa7e-8edb2920cfc8',
    ROW_NUM: 29,
    NAVIO: 'CONSTANTIA',
    VIAGEM: '379473 - 242W/242W',
    JOINT: 'COS',
    ABERTURAGATE: '2022-10-15T00:01:00Z',
    BERCO: 'TECON1.2',
    DEADLINE: '2022-10-20T15:00:00Z',
    PREVISAOCHEGADA: '2022-10-21T15:00:00Z',
    CHEGADA: '2022-10-21T18:00:00Z',
    ATRACACAO: '2022-10-21T19:34:00Z',
    INICIOOPERACAO: '2022-10-21T20:15:00Z',
    TERMINO: '2022-10-22T10:37:00Z',
    SAIDA: '2022-10-22T10:40:00Z',
  },
  {
    '@odata.etag': '',
    ItemInternalId: '62cd344c-89bc-4865-82b4-a54e6683e4a5',
    ROW_NUM: 30,
    NAVIO: 'LOGIN RESILIENTE',
    VIAGEM: '380743 - 343N/343N',
    JOINT: 'FED',
    ABERTURAGATE: '2022-10-14T00:00:00Z',
    BERCO: 'TECON1.2',
    DEADLINE: '2022-10-19T17:00:00Z',
    PREVISAOCHEGADA: '2022-10-20T16:00:00Z',
    CHEGADA: '2022-10-20T17:00:00Z',
    ATRACACAO: '2022-10-20T19:00:00Z',
    INICIOOPERACAO: '2022-10-20T19:15:00Z',
    TERMINO: '2022-10-20T23:45:00Z',
    SAIDA: '2022-10-21T01:05:00Z',
  },
  {
    '@odata.etag': '',
    ItemInternalId: 'cc573b80-58a0-4796-b333-808da5e2c575',
    ROW_NUM: 31,
    NAVIO: 'EVER LIFTING',
    VIAGEM: '13412 - 1503-046W/1503-046W',
    JOINT: 'SE1',
    ABERTURAGATE: '2022-10-13T07:00:00Z',
    BERCO: 'PROLONGAM',
    DEADLINE: '2022-10-20T12:00:00Z',
    PREVISAOCHEGADA: '2022-10-20T12:00:00Z',
    CHEGADA: '2022-10-20T12:00:00Z',
    ATRACACAO: '2022-10-20T14:00:00Z',
    INICIOOPERACAO: '2022-10-20T14:15:00Z',
    TERMINO: '2022-10-22T13:30:00Z',
    SAIDA: '2022-10-22T14:15:00Z',
  },
  {
    '@odata.etag': '',
    ItemInternalId: '1a99639e-04fd-4043-87eb-5fcd72285734',
    ROW_NUM: 32,
    NAVIO: 'BASILISK',
    VIAGEM: '386495 - 20221019/20221019',
    JOINT: 'GEN',
    ABERTURAGATE: '2022-10-18T07:00:00Z',
    BERCO: 'PROLONGAM',
    DEADLINE: '2022-10-19T17:00:00Z',
    PREVISAOCHEGADA: '2022-10-19T17:00:00Z',
    CHEGADA: '2022-10-19T17:00:00Z',
    ATRACACAO: '2022-10-19T18:25:00Z',
    INICIOOPERACAO: '2022-10-19T19:58:00Z',
    TERMINO: '2022-10-19T22:30:00Z',
    SAIDA: '2022-10-20T02:00:00Z',
  },
  {
    '@odata.etag': '',
    ItemInternalId: '70d5f67e-2dcd-4252-8af7-e271ef11e90f',
    ROW_NUM: 33,
    NAVIO: 'MSC GISELLE',
    VIAGEM: '385790 - MM238A/MM238A',
    JOINT: 'MED',
    ABERTURAGATE: '2022-10-13T00:00:00Z',
    DEADLINE: '2022-10-15T12:00:00Z',
    PREVISAOCHEGADA: '2022-10-19T07:00:00Z',
  },
  {
    '@odata.etag': '',
    ItemInternalId: 'fe2fae46-6504-47aa-8040-274b0b36888a',
    ROW_NUM: 34,
    NAVIO: 'DUBLIN EXPRESS',
    VIAGEM: '13414 - 240N/240N',
    JOINT: 'TGO',
    ABERTURAGATE: '2022-10-11T00:01:00Z',
    BERCO: 'PROLONGAM',
    DEADLINE: '2022-10-14T17:00:00Z',
    PREVISAOCHEGADA: '2022-10-17T21:00:00Z',
    CHEGADA: '2022-10-17T21:30:00Z',
    ATRACACAO: '2022-10-17T23:02:00Z',
    INICIOOPERACAO: '2022-10-17T23:10:00Z',
    TERMINO: '2022-10-18T10:50:00Z',
    SAIDA: '2022-10-18T12:00:00Z',
  },
  {
    '@odata.etag': '',
    ItemInternalId: '7c804e09-6f18-481a-8e26-ff8833527142',
    ROW_NUM: 35,
    NAVIO: 'LOGIN JATOBA',
    VIAGEM: '378041 - 233N/233N',
    JOINT: 'TRP',
    ABERTURAGATE: '2022-10-11T00:00:00Z',
    BERCO: 'PROLONGAM',
    DEADLINE: '2022-10-17T14:00:00Z',
    PREVISAOCHEGADA: '2022-10-17T10:00:00Z',
    CHEGADA: '2022-10-17T11:10:00Z',
    ATRACACAO: '2022-10-17T11:40:00Z',
    INICIOOPERACAO: '2022-10-17T12:30:00Z',
    TERMINO: '2022-10-17T18:23:00Z',
    SAIDA: '2022-10-17T20:15:00Z',
  },
  {
    '@odata.etag': '',
    ItemInternalId: '1bf2c2ea-fdf3-4611-af7a-13b6226d168c',
    ROW_NUM: 36,
    NAVIO: 'MSC SOFIA CELESTE',
    VIAGEM: '384798 - NA237A/NA237A',
    JOINT: 'NWC',
    ABERTURAGATE: '2022-10-10T00:00:00Z',
    DEADLINE: '2022-10-14T17:00:00Z',
    PREVISAOCHEGADA: '2022-10-16T19:00:00Z',
  },
  {
    '@odata.etag': '',
    ItemInternalId: 'aa75e28b-cdae-4118-929e-6c30fe495d34',
    ROW_NUM: 37,
    NAVIO: 'MERCOSUL SUAPE',
    VIAGEM: '13411 - 0BCC5N1RC/0BCC5N1RC',
    JOINT: 'BCO',
    ABERTURAGATE: '2022-10-10T00:01:00Z',
    BERCO: 'PROLONGAM',
    DEADLINE: '2022-10-14T12:00:00Z',
    PREVISAOCHEGADA: '2022-10-16T05:00:00Z',
    CHEGADA: '2022-10-16T05:01:00Z',
    ATRACACAO: '2022-10-16T06:31:00Z',
    INICIOOPERACAO: '2022-10-16T07:20:00Z',
    TERMINO: '2022-10-16T12:55:00Z',
    SAIDA: '2022-10-16T13:25:00Z',
  },
  {
    '@odata.etag': '',
    ItemInternalId: '61dee16a-c3bd-401a-91fe-444e2f5c5135',
    ROW_NUM: 38,
    NAVIO: 'UASC ZAMZAM',
    VIAGEM: '383692 - NA239R/NA239R',
    JOINT: 'NWC',
    ABERTURAGATE: '2022-10-09T00:00:00Z',
    DEADLINE: '2022-10-11T17:00:00Z',
    PREVISAOCHEGADA: '2022-10-15T11:30:00Z',
  },
  {
    '@odata.etag': '',
    ItemInternalId: '5d570a19-25df-490a-a317-915530636319',
    ROW_NUM: 39,
    NAVIO: 'SAN ANTONIO EXPRESS',
    VIAGEM: '369482 - 241W/241W',
    JOINT: 'COS',
    ABERTURAGATE: '2022-10-09T00:01:00Z',
    BERCO: 'PROLONGAM',
    DEADLINE: '2022-10-13T12:00:00Z',
    PREVISAOCHEGADA: '2022-10-15T00:30:00Z',
    CHEGADA: '2022-10-14T23:24:00Z',
    ATRACACAO: '2022-10-15T01:15:00Z',
    INICIOOPERACAO: '2022-10-15T02:40:00Z',
    TERMINO: '2022-10-15T09:30:00Z',
    SAIDA: '2022-10-15T11:05:00Z',
  },
  {
    '@odata.etag': '',
    ItemInternalId: '6541b41f-daff-4e29-82d4-85e704dfd2cf',
    ROW_NUM: 40,
    NAVIO: 'LOGIN RESILIENTE',
    VIAGEM: '373706 - 342N/342N',
    JOINT: 'FED',
    ABERTURAGATE: '2022-10-08T00:00:00Z',
    BERCO: 'PROLONGAM',
    DEADLINE: '2022-10-11T17:00:00Z',
    PREVISAOCHEGADA: '2022-10-14T03:00:00Z',
    CHEGADA: '2022-10-14T00:50:00Z',
    ATRACACAO: '2022-10-14T04:45:00Z',
    INICIOOPERACAO: '2022-10-14T06:01:00Z',
    TERMINO: '2022-10-14T08:55:00Z',
    SAIDA: '2022-10-14T11:00:00Z',
  },
  {
    '@odata.etag': '',
    ItemInternalId: 'be07b0d2-648d-432c-a0bb-06466ea0beed',
    ROW_NUM: 41,
    NAVIO: 'MONTE VERDE',
    VIAGEM: '13408 - 239N/239N',
    JOINT: 'TGO',
    ABERTURAGATE: '2022-10-04T00:01:00Z',
    BERCO: 'PROLONGAM',
    DEADLINE: '2022-10-07T17:00:00Z',
    PREVISAOCHEGADA: '2022-10-10T15:00:00Z',
    CHEGADA: '2022-10-10T15:00:00Z',
    ATRACACAO: '2022-10-10T16:21:00Z',
    INICIOOPERACAO: '2022-10-10T17:57:00Z',
    TERMINO: '2022-10-11T00:17:00Z',
    SAIDA: '2022-10-11T01:15:00Z',
  },
  {
    '@odata.etag': '',
    ItemInternalId: 'e05d102a-09bf-4b1b-bc4f-1b8829f5e5a0',
    ROW_NUM: 42,
    NAVIO: 'MERCOSUL SANTOS',
    VIAGEM: '13407 - 0BCC3N1RC/0BCC3N1RC',
    JOINT: 'BCO',
    ABERTURAGATE: '2022-10-01T00:00:00Z',
    BERCO: 'TECON1.2',
    DEADLINE: '2022-10-07T15:30:00Z',
    PREVISAOCHEGADA: '2022-10-09T06:00:00Z',
    CHEGADA: '2022-10-09T05:00:00Z',
    ATRACACAO: '2022-10-09T06:30:00Z',
    INICIOOPERACAO: '2022-10-09T07:00:00Z',
    TERMINO: '2022-10-09T13:36:00Z',
    SAIDA: '2022-10-09T15:15:00Z',
  },
  {
    '@odata.etag': '',
    ItemInternalId: 'bc4a69da-40b7-469b-92a0-0d0ff4570730',
    ROW_NUM: 43,
    NAVIO: 'GEMLIK EXPRESS',
    VIAGEM: '367441 - 240W/240W',
    JOINT: 'COS',
    ABERTURAGATE: '2022-10-01T07:00:00Z',
    BERCO: 'PROLONGAM',
    DEADLINE: '2022-10-06T12:00:00Z',
    PREVISAOCHEGADA: '2022-10-07T23:15:00Z',
    CHEGADA: '2022-10-07T23:00:00Z',
    ATRACACAO: '2022-10-08T00:15:00Z',
    INICIOOPERACAO: '2022-10-08T00:50:00Z',
    TERMINO: '2022-10-08T07:56:00Z',
    SAIDA: '2022-10-08T08:10:00Z',
  },
  {
    '@odata.etag': '',
    ItemInternalId: 'c1b35b16-1568-4322-9625-22f88f525c80',
    ROW_NUM: 44,
    NAVIO: 'MEHUIN',
    VIAGEM: '376344 - NA236A/NA236A',
    JOINT: 'NWC',
    ABERTURAGATE: '2022-10-01T00:00:00Z',
    DEADLINE: '2022-10-06T12:00:00Z',
    PREVISAOCHEGADA: '2022-10-07T19:00:00Z',
  },
  {
    '@odata.etag': '',
    ItemInternalId: '94822184-f50a-44d3-8392-51a05cfada0e',
    ROW_NUM: 45,
    NAVIO: 'LOGIN RESILIENTE',
    VIAGEM: '13404 - 341N/341N',
    JOINT: 'FED',
    ABERTURAGATE: '2022-10-01T00:00:00Z',
    BERCO: 'TECON1.2',
    DEADLINE: '2022-10-05T17:00:00Z',
    PREVISAOCHEGADA: '2022-10-07T02:30:00Z',
    CHEGADA: '2022-10-07T03:00:00Z',
    ATRACACAO: '2022-10-07T04:30:00Z',
    INICIOOPERACAO: '2022-10-07T04:35:00Z',
    TERMINO: '2022-10-07T09:10:00Z',
    SAIDA: '2022-10-07T12:10:00Z',
  },
  {
    '@odata.etag': '',
    ItemInternalId: '658cd8d9-ddc1-43ef-bfe5-b9142163679f',
    ROW_NUM: 46,
    NAVIO: 'MONTE AZUL',
    VIAGEM: '13403 - 238N/238N',
    JOINT: 'TGO',
    ABERTURAGATE: '2022-09-27T00:01:00Z',
    BERCO: 'TECON1.2',
    DEADLINE: '2022-09-30T17:00:00Z',
    PREVISAOCHEGADA: '2022-10-05T09:00:00Z',
    CHEGADA: '2022-10-05T10:00:00Z',
    ATRACACAO: '2022-10-05T11:10:00Z',
    INICIOOPERACAO: '2022-10-05T11:20:00Z',
    TERMINO: '2022-10-05T23:50:00Z',
    SAIDA: '2022-10-06T06:15:00Z',
  },
  {
    '@odata.etag': '',
    ItemInternalId: '4dc9719b-51d2-4200-9b29-3465a47195b4',
    ROW_NUM: 47,
    NAVIO: 'MSC SILVIA',
    VIAGEM: '377628 - MM236A-1/MM236A-1',
    JOINT: 'MED',
    ABERTURAGATE: '2022-09-28T00:00:00Z',
    DEADLINE: '2022-10-03T12:00:00Z',
    PREVISAOCHEGADA: '2022-10-04T09:00:00Z',
  },
  {
    '@odata.etag': '',
    ItemInternalId: '4d52b1c5-4356-4792-be35-11d490bd3769',
    ROW_NUM: 48,
    NAVIO: 'NORTHERN DELEGATION',
    VIAGEM: '13401 - 016N/016N',
    JOINT: 'BZX',
    ABERTURAGATE: '2022-09-25T00:00:00Z',
    BERCO: 'TECON1.2',
    DEADLINE: '2022-10-01T11:00:00Z',
    PREVISAOCHEGADA: '2022-10-04T02:30:00Z',
    CHEGADA: '2022-10-04T02:31:00Z',
    ATRACACAO: '2022-10-04T03:44:00Z',
    INICIOOPERACAO: '2022-10-04T03:55:00Z',
    TERMINO: '2022-10-04T12:47:00Z',
    SAIDA: '2022-10-04T14:16:00Z',
  },
  {
    '@odata.etag': '',
    ItemInternalId: '96e44898-77f3-4a3d-8e9d-634c9b298bc0',
    ROW_NUM: 49,
    NAVIO: 'MERCOSUL ITAJAI',
    VIAGEM: '13402 - 0BCC1N1RC/0BCC1N1RC',
    JOINT: 'BCO',
    ABERTURAGATE: '2022-09-26T00:01:00Z',
    BERCO: 'TECON1.2',
    DEADLINE: '2022-09-30T12:00:00Z',
    PREVISAOCHEGADA: '2022-10-02T05:00:00Z',
    CHEGADA: '2022-10-02T05:00:00Z',
    ATRACACAO: '2022-10-02T06:30:00Z',
    INICIOOPERACAO: '2022-10-02T07:50:00Z',
    TERMINO: '2022-10-02T12:43:00Z',
    SAIDA: '2022-10-02T14:16:00Z',
  },
  {
    '@odata.etag': '',
    ItemInternalId: 'e49b371c-7f80-46ee-8ede-4ffa8d8e6a06',
    ROW_NUM: 50,
    NAVIO: 'MSC MICHELA',
    VIAGEM: '372626 - NA235A/NA235A',
    JOINT: 'NWC',
    ABERTURAGATE: '2022-09-25T00:00:00Z',
    DEADLINE: '2022-09-29T12:00:00Z',
    PREVISAOCHEGADA: '2022-10-01T07:30:00Z',
  },
  {
    '@odata.etag': '',
    ItemInternalId: '34eb07a0-3558-4d11-85c8-61df75e0d591',
    ROW_NUM: 51,
    NAVIO: 'MSC TAVVISHI',
    VIAGEM: '371764 - UA236R/UA236R',
    JOINT: 'USA',
    ABERTURAGATE: '2022-09-25T00:00:00Z',
    DEADLINE: '2022-09-27T18:30:00Z',
    PREVISAOCHEGADA: '2022-09-30T23:01:00Z',
  },
  {
    '@odata.etag': '',
    ItemInternalId: '4f9a2f05-25b2-4491-bf08-f9554c28c4e7',
    ROW_NUM: 52,
    NAVIO: 'GSL ELEFTHERIA',
    VIAGEM: '13400 - 239W/239W',
    JOINT: 'COS',
    ABERTURAGATE: '2022-09-25T00:01:00Z',
    BERCO: 'TECON1.2',
    DEADLINE: '2022-09-29T17:00:00Z',
    PREVISAOCHEGADA: '2022-09-30T19:00:00Z',
    CHEGADA: '2022-09-30T18:55:00Z',
    ATRACACAO: '2022-09-30T20:12:00Z',
    INICIOOPERACAO: '2022-09-30T22:12:00Z',
    TERMINO: '2022-10-01T11:10:00Z',
    SAIDA: '2022-10-01T13:15:00Z',
  },
  {
    '@odata.etag': '',
    ItemInternalId: '3ed226eb-8326-4354-82fb-3fa5de0cc990',
    ROW_NUM: 53,
    NAVIO: 'COSCO SHIPPING DANUBE',
    VIAGEM: '13397 - 033W/033W',
    JOINT: 'SE1',
    ABERTURAGATE: '2022-09-26T00:00:00Z',
    BERCO: 'PROLONGAM',
    DEADLINE: '2022-09-28T12:00:00Z',
    PREVISAOCHEGADA: '2022-09-30T09:00:00Z',
    CHEGADA: '2022-09-30T07:00:00Z',
    ATRACACAO: '2022-09-30T10:30:00Z',
    INICIOOPERACAO: '2022-09-30T10:36:00Z',
    TERMINO: '2022-10-01T10:21:00Z',
    SAIDA: '2022-10-01T14:00:00Z',
  },
  {
    '@odata.etag': '',
    ItemInternalId: '13eabfa4-890c-4bc3-879f-384bef6bd950',
    ROW_NUM: 54,
    NAVIO: 'LOGIN RESILIENTE',
    VIAGEM: '13396 - 288N/288N',
    JOINT: 'FED',
    ABERTURAGATE: '2022-09-24T00:00:00Z',
    BERCO: 'TECON1.2',
    DEADLINE: '2022-09-29T11:00:00Z',
    PREVISAOCHEGADA: '2022-09-30T05:00:00Z',
    CHEGADA: '2022-09-30T05:00:00Z',
    ATRACACAO: '2022-09-30T06:20:00Z',
    INICIOOPERACAO: '2022-09-30T08:55:00Z',
    TERMINO: '2022-09-30T12:11:00Z',
    SAIDA: '2022-09-30T13:51:00Z',
  },
  {
    '@odata.etag': '',
    ItemInternalId: 'b8f609e4-1f38-4284-a9c7-c6cf7ecd618c',
    ROW_NUM: 55,
    NAVIO: 'CMA CGM JACQUES JUNIOR',
    VIAGEM: '367781 - 0AACTW1MA/0AACTW1MA',
    JOINT: 'SE1',
    ABERTURAGATE: '2022-09-21T07:00:00Z',
    BERCO: 'PROLONGAM',
    DEADLINE: '2022-09-26T17:00:00Z',
    PREVISAOCHEGADA: '2022-09-27T01:00:00Z',
    CHEGADA: '2022-09-27T01:04:00Z',
    ATRACACAO: '2022-09-27T03:15:00Z',
    INICIOOPERACAO: '2022-09-27T05:36:00Z',
    TERMINO: '2022-09-28T15:22:00Z',
    SAIDA: '2022-09-28T15:30:00Z',
  },
  {
    '@odata.etag': '',
    ItemInternalId: '736d033c-ace7-4648-9029-a445fb355333',
    ROW_NUM: 56,
    NAVIO: 'MSC ATHOS',
    VIAGEM: '370357 - MM235A/MM235A',
    JOINT: 'MED',
    ABERTURAGATE: '2022-09-20T00:00:00Z',
    DEADLINE: '2022-09-23T17:00:00Z',
    PREVISAOCHEGADA: '2022-09-26T17:00:00Z',
  },
  {
    '@odata.etag': '',
    ItemInternalId: 'b4ee2e69-a326-490a-aff3-2d19bd721104',
    ROW_NUM: 57,
    NAVIO: 'LOG-IN POLARIS',
    VIAGEM: '13392 - 074N/074N',
    JOINT: 'BCO',
    ABERTURAGATE: '2022-09-18T00:01:00Z',
    BERCO: 'TECON1.2',
    DEADLINE: '2022-09-23T12:00:00Z',
    PREVISAOCHEGADA: '2022-09-25T05:10:00Z',
    CHEGADA: '2022-09-25T08:00:00Z',
    ATRACACAO: '2022-09-25T09:15:00Z',
    INICIOOPERACAO: '2022-09-25T10:15:00Z',
    TERMINO: '2022-09-25T21:41:00Z',
    SAIDA: '2022-09-25T21:45:00Z',
  },
  {
    '@odata.etag': '',
    ItemInternalId: 'ceee5750-5380-4722-8493-f89a65848e99',
    ROW_NUM: 58,
    NAVIO: 'GENTOS',
    VIAGEM: '367121 - 123/123',
    JOINT: 'GEN',
    ABERTURAGATE: '2022-09-24T07:00:00Z',
    DEADLINE: '2035-09-24T22:00:00Z',
    PREVISAOCHEGADA: '2022-09-24T22:00:00Z',
  },
  {
    '@odata.etag': '',
    ItemInternalId: '6c738438-2394-404e-bbc0-8f1443638e96',
    ROW_NUM: 59,
    NAVIO: 'ANTOFAGASTA EXPRESS',
    VIAGEM: '13391 - 238W/238W',
    JOINT: 'COS',
    ABERTURAGATE: '2022-09-18T00:00:00Z',
    BERCO: 'TECON1.2',
    DEADLINE: '2022-09-22T12:00:00Z',
    PREVISAOCHEGADA: '2022-09-24T07:00:00Z',
    CHEGADA: '2022-09-24T07:00:00Z',
    ATRACACAO: '2022-09-24T08:20:00Z',
    INICIOOPERACAO: '2022-09-24T10:00:00Z',
    TERMINO: '2022-09-24T19:26:00Z',
    SAIDA: '2022-09-24T19:40:00Z',
  },
  {
    '@odata.etag': '',
    ItemInternalId: '58ae5e5e-00a0-4bdc-9b0a-d538a7db2cae',
    ROW_NUM: 60,
    NAVIO: 'LOGIN RESILIENTE',
    VIAGEM: '13389 - 287N/287N',
    RAP: '07546 2022',
    JOINT: 'FED',
    ABERTURAGATE: '2022-09-17T00:00:00Z',
    BERCO: 'TECON1.1',
    DEADLINE: '2022-09-21T17:00:00Z',
    PREVISAOCHEGADA: '2022-09-22T16:20:00Z',
    CHEGADA: '2022-09-22T16:35:00Z',
    ATRACACAO: '2022-09-22T16:35:00Z',
    INICIOOPERACAO: '2022-09-22T17:48:00Z',
    TERMINO: '2022-09-22T19:38:00Z',
    SAIDA: '2022-09-23T09:10:00Z',
  },
  {
    '@odata.etag': '',
    ItemInternalId: 'ca6497c9-88bb-47fa-bb21-14b8e2172f56',
    ROW_NUM: 61,
    NAVIO: 'MSC ALESSIA',
    VIAGEM: '367862 - UA230A/UA230A',
    JOINT: 'US1',
    ABERTURAGATE: '2022-09-18T00:00:00Z',
    DEADLINE: '2022-09-19T12:00:00Z',
    PREVISAOCHEGADA: '2022-09-22T07:30:00Z',
  },
  {
    '@odata.etag': '',
    ItemInternalId: 'cb69b9a9-987c-4aff-b659-c8cb914c7c65',
    ROW_NUM: 62,
    NAVIO: 'GRANDE AMBURGO',
    VIAGEM: '367161 - 622SA/622SA',
    JOINT: 'GRI',
    ABERTURAGATE: '2022-09-21T17:00:00Z',
    DEADLINE: '2022-09-22T18:00:00Z',
    PREVISAOCHEGADA: '2022-09-21T17:00:00Z',
  },
  {
    '@odata.etag': '',
    ItemInternalId: '04b4cc08-1f5d-40a2-a39f-613e4b35944d',
    ROW_NUM: 63,
    NAVIO: 'MONTE CERVANTES',
    VIAGEM: '13335 - 236N/236S',
    RAP: '07355/2022',
    JOINT: 'TGO',
    ABERTURAGATE: '2022-09-13T00:01:00Z',
    BERCO: 'TECON1.1',
    DEADLINE: '2022-09-16T18:05:00Z',
    PREVISAOCHEGADA: '2022-09-19T08:00:00Z',
    CHEGADA: '2022-09-19T10:00:00Z',
    ATRACACAO: '2022-09-19T10:00:00Z',
    INICIOOPERACAO: '2022-09-19T11:28:00Z',
    TERMINO: '2022-09-19T16:38:00Z',
    SAIDA: '2022-09-20T11:10:00Z',
  },
  {
    '@odata.etag': '',
    ItemInternalId: '58fff3cb-384e-4362-9b70-c66bb9e24aa0',
    ROW_NUM: 64,
    NAVIO: 'COSCO SHIPPING RHINE',
    VIAGEM: '13336 - 027W/027W',
    RAP: '07320/2022',
    JOINT: 'SE1',
    ABERTURAGATE: '2022-09-12T00:00:00Z',
    BERCO: 'TECON1.1',
    DEADLINE: '2022-09-16T12:00:00Z',
    PREVISAOCHEGADA: '2022-09-19T08:00:00Z',
    CHEGADA: '2022-09-19T19:05:00Z',
    ATRACACAO: '2022-09-19T19:05:00Z',
    INICIOOPERACAO: '2022-09-19T20:53:00Z',
    TERMINO: '2022-09-20T11:52:00Z',
    SAIDA: '2022-09-20T15:45:00Z',
  },
];
